// extracted by mini-css-extract-plugin
export default {"cardTok":"CardTok_cardTok__ME4Bl","line":"CardTok_line__jdnwi"};